import { render, staticRenderFns } from "./CampPartsScrollFixTable.vue?vue&type=template&id=47f4ba0b&lang=pug&"
import script from "./CampPartsScrollFixTable.vue?vue&type=script&lang=js&"
export * from "./CampPartsScrollFixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports